/**
 * Pre-compiled fr-FR messages for Alert
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { dismiss: `Fermer` };
